import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import ShopHeader from "@/components/ShopHeader";
import SiteBanner from "@/components/SiteBanner";
import api from "@/lib/api";

export default function PublicShell({ children }) {
  const [legal, setLegal] = useState([]);

  useEffect(() => {
    api.get("/legal").then((r) => {
      const list = r.data?.policies || r.data?.pages || r.data?.items || r.data?.legal || [];
      setLegal(Array.isArray(list) ? list : []);
    }).catch(() => {});
  }, []);

  return (
    <div className="flex min-h-screen flex-col bg-slate-50" data-testid="public-shell">
      <SiteBanner />
      <ShopHeader />

      <main className="mx-auto w-full max-w-7xl flex-1 px-4 py-6">{children}</main>

      <footer className="border-t border-slate-200 bg-slate-50" data-testid="public-footer">
        <div className="mx-auto grid max-w-7xl gap-8 px-4 py-10 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <Logo variant="sm" />
            <p className="mt-3 text-sm font-semibold text-slate-700">AI-Powered Marketplace</p>
            <p className="text-xs text-slate-400">Shop. Discover. Suffle.</p>
          </div>
          <div>
            <p className="mb-3 text-sm font-semibold text-slate-800">Marketplace</p>
            <ul className="space-y-2 text-sm text-slate-500">
              <li><Link to="/shop" className="hover:text-blue-600">Shop</Link></li>
              <li><Link to="/services" className="hover:text-blue-600">Services</Link></li>
              <li><Link to="/shop" className="hover:text-blue-600">Categories</Link></li>
              <li><Link to="/deals" className="hover:text-blue-600">Deals</Link></li>
              <li><Link to="/sellers" className="hover:text-blue-600">Sellers</Link></li>
              <li><Link to="/register" className="hover:text-blue-600">Sell on Suffle</Link></li>
            </ul>
          </div>
          <div>
            <p className="mb-3 text-sm font-semibold text-slate-800">Account &amp; Support</p>
            <ul className="space-y-2 text-sm text-slate-500">
              <li><Link to="/login" className="hover:text-blue-600">Orders</Link></li>
              <li><Link to="/login" className="hover:text-blue-600">Wishlist</Link></li>
              <li><Link to="/login" className="hover:text-blue-600">Account</Link></li>
              <li><Link to="/help" className="hover:text-blue-600">Support</Link></li>
              <li><Link to="/contact" className="hover:text-blue-600">Contact Us</Link></li>
            </ul>
          </div>
          <div>
            <p className="mb-3 text-sm font-semibold text-slate-800">Legal</p>
            <ul className="space-y-2 text-sm text-slate-500" data-testid="footer-legal">
              {legal.length > 0 ? legal.slice(0, 12).map((p) => (
                <li key={p.slug}><Link to={`/legal/${p.slug}`} className="hover:text-blue-600">{p.title}</Link></li>
              )) : <li><Link to="/legal" className="hover:text-blue-600">All Policies</Link></li>}
              <li><Link to="/legal/grievance-contact" className="hover:text-blue-600">Grievance Redressal</Link></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-slate-200 py-4 text-center text-xs text-slate-400">© {new Date().getFullYear()} Suffle Online · Naucera Travel Private Limited · Shop. Discover. Suffle.</div>
      </footer>
    </div>
  );
}
